module.exports = __webpack_public_path__ + "img/1556284555.9538edbd.jpg";